import { serverFetch } from "@core/server";

export function fetchUserMonitorList({
  dateBeg,
  dateEnd,
  vid,
  vidFrom,
  vidTo,
  idObjZag,
  userName,
  q,
  sortBy,
  sortDir,
  skip = 0,
  take = 50
} = {}) {
  return serverFetch("service/monitor", {
    queryParams: {
      skip,
      take,
      ...(dateBeg ? { dateBeg } : {}),
      ...(dateEnd ? { dateEnd } : {}),
      ...(vid != null && vid !== "" ? { vid } : {}),
      ...(vidFrom != null && vidFrom !== "" ? { vidFrom } : {}),
      ...(vidTo != null && vidTo !== "" ? { vidTo } : {}),
      ...(idObjZag != null && idObjZag !== "" ? { idObjZag } : {}),
      ...(userName ? { userName } : {}),
      ...(q ? { q } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(sortDir ? { sortDir } : {})
    }
  });
}

export function fetchUserMonitorLookups() {
  return serverFetch("service/monitor/lookups");
}
